import React from "react";
import ReactDOM from "react-dom";

import "../node_modules/uikit/dist/css/uikit.min.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "./styles/style.css";

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";

import reduxThunk from "redux-thunk";

import createHistory from "history/createBrowserHistory";
import { ConnectedRouter, routerMiddleware } from "react-router-redux";

import rootReducer from "./store";

import * as pages from "./ui/pages";
import { ScrollToTop } from "./ui/elements";

const history = createHistory();
const reduxRouter = routerMiddleware(history);

const store = createStore(
  rootReducer,
  applyMiddleware(reduxThunk, reduxRouter)
);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <ScrollToTop>
          <Route
            exact
            path="/privacy-policy"
            component={pages.PrivacyPolicyPage}
          />

          <Route exact path="/avvisi" component={pages.NewsPage} />

          <Route exact path="/contatti" component={pages.HomePage} />
          <Route
            exact
            path="/prenota-una-prova-gratuita"
            component={pages.HomePage}
          />
          <Route exact path="/" component={pages.HomePage} />
        </ScrollToTop>
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js